import fetch from '../fetch';
import EndPoints from '../../data/EndPoints';
import Methods from '../../data/Methods';

export default (companyId, draftId) => {
	const url = EndPoints.COMPANY_DRAFT.replace(':companyId', companyId).replace(':draftId', draftId);
	return fetch(Methods.DELETE, url, null, null, true);
};
